/* ==========================================================================
   LUNEXUS.WORLD — Globales Custom-JavaScript
   Gilt auf ALLEN Seiten (Homepage, Produkt, Kollektion, Suche etc.)
   Version: 2.0 — Bereinigt am 24.03.2026
   ========================================================================== */

(function() {
  'use strict';

  /* --- LÖSCHEN-Button: Lila Pill per JS erzwingen --- */
  function styleClearButtons() {
    document.querySelectorAll('button.predictive-search-results__clear').forEach(function(btn) {
      if (btn.dataset.styled) return;
      btn.dataset.styled = '1';
      btn.style.setProperty('background', '#914f9e', 'important');
      btn.style.setProperty('background-color', '#914f9e', 'important');
      btn.style.setProperty('color', '#fff', 'important');
      btn.style.setProperty('border', 'none', 'important');
      btn.style.setProperty('border-radius', '100px', 'important');
      btn.style.setProperty('padding', '6px 18px', 'important');
      btn.style.setProperty('font-size', '0.75rem', 'important');
      btn.style.setProperty('font-weight', '600', 'important');
      btn.style.setProperty('cursor', 'pointer', 'important');
      btn.style.setProperty('text-decoration', 'none', 'important');
      btn.style.setProperty('opacity', '1', 'important');
      btn.addEventListener('mouseenter', function() {
        this.style.setProperty('background', '#7a3f87', 'important');
        this.style.setProperty('background-color', '#7a3f87', 'important');
      });
      btn.addEventListener('mouseleave', function() {
        this.style.setProperty('background', '#914f9e', 'important');
        this.style.setProperty('background-color', '#914f9e', 'important');
      });
    });
  }

  /* --- Suchergebnis-Layout fixieren --- */
  function fixLayout() {
    document.querySelectorAll('.predictive-search-results__inner').forEach(function(el) {
      if (el.dataset.fixed) return;
      el.dataset.fixed = '1';
      el.style.setProperty('overflow-y', 'visible', 'important');
      el.style.setProperty('overflow', 'visible', 'important');
      el.style.setProperty('max-height', 'none', 'important');
      el.style.setProperty('flex-grow', 'unset', 'important');
      el.style.setProperty('padding-bottom', '1rem', 'important');
    });
    document.querySelectorAll('.predictive-search-form__content').forEach(function(el) {
      if (el.dataset.fixed) return;
      el.dataset.fixed = '1';
      el.style.setProperty('max-height', 'none', 'important');
      el.style.setProperty('overflow', 'visible', 'important');
    });
    var isMobile = window.innerWidth <= 768;
    document.querySelectorAll('.predictive-search-form__content-wrapper').forEach(function(el) {
      if (el.dataset.fixed) return;
      el.dataset.fixed = '1';
      if (isMobile) {
        el.style.setProperty('max-height', '70vh', 'important');
        el.style.setProperty('overflow-y', 'auto', 'important');
        el.style.setProperty('overflow-x', 'hidden', 'important');
        el.style.setProperty('-webkit-overflow-scrolling', 'touch', 'important');
      } else {
        el.style.setProperty('max-height', 'none', 'important');
        el.style.setProperty('overflow', 'hidden', 'important');
      }
      el.style.setProperty('border-radius', '20px', 'important');
    });
    document.querySelectorAll('.predictive-search-dropdown').forEach(function(el) {
      el.style.setProperty('box-shadow', 'none', 'important');
    });
  }

  /* --- MutationObserver statt setInterval (90% weniger CPU) --- */
  var observer = new MutationObserver(function() {
    styleClearButtons();
    fixLayout();
  });

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true
  });

  /* --- Initial run --- */
  styleClearButtons();
  fixLayout();

  document.addEventListener('DOMContentLoaded', function() {
    styleClearButtons();
    fixLayout();
  });


  /* --- Inline-Suchleiste (predictive-search-component.add-one): Dropdown nur bei Fokus/Eingabe --- */
  var lxLastIntent = 0;
  ['pointerdown', 'touchstart', 'keydown'].forEach(function(ev) {
    document.addEventListener(ev, function() { lxLastIntent = Date.now(); }, true);
  });
  function initInlineSearch() {
    document.querySelectorAll('predictive-search-component.add-one').forEach(function(c) {
      if (c.dataset.lxSearchInit) return;
      c.dataset.lxSearchInit = '1';
      var input = c.querySelector('.search-input');
      if (!input) return;
      function open() { c.classList.add('lx-sopen'); input.setAttribute('aria-expanded', 'true'); }
      function close(blur) {
        c.classList.remove('lx-sopen');
        input.setAttribute('aria-expanded', 'false');
        if (blur) input.blur();
      }
      /* Fokus nur dann als "oeffnen" werten, wenn er durch Nutzer-Eingabe entstand (predictive-search.js fokussiert die Eingabe programmatisch beim Laden der Zuletzt-angesehen-Liste) */
      input.addEventListener('focus', function() { if (Date.now() - lxLastIntent < 700) open(); });
      input.addEventListener('click', open);
      input.addEventListener('input', open);
      c.addEventListener('keydown', function(e) {
        if (e.key === 'Escape') { close(true); }
      }, true);
      document.addEventListener('pointerdown', function(e) {
        if (!c.contains(e.target)) close(false);
      });
      document.addEventListener('focusin', function(e) {
        if (!c.contains(e.target)) close(false);
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initInlineSearch);
  else initInlineSearch();

  /* --- Cart Assets: Dynamisch nachladen falls nicht vorhanden --- */
  (function(){
    var cssLoaded=document.querySelector('link[href*="lunexus-cart.css"]');
    var jsLoaded=document.querySelector('script[src*="lunexus-cart.js"]');
    if(!cssLoaded){
      var base=document.querySelector('link[href*="lunexus-custom.css"]');
      if(base){
        var cssUrl=base.href.replace('lunexus-custom.css','lunexus-cart.css').split('?')[0];
        var link=document.createElement('link');
        link.rel='stylesheet';link.href=cssUrl;
        document.head.appendChild(link);
      }
    }
    if(!jsLoaded){
      var baseJs=document.querySelector('script[src*="lunexus-custom.js"]');
      if(baseJs){
        var jsUrl=baseJs.src.replace('lunexus-custom.js','lunexus-cart.js').split('?')[0];
        var script=document.createElement('script');
        script.src=jsUrl;script.defer=true;
        document.head.appendChild(script);
      }
    }
  })();
})();
